import { useImpactPageData } from '#src/app/pages/about/impact/pageContext';
import type { ImpactPageData } from '#src/app/pages/about/impact/pageContext';

type Result = ModelHookResult<{
	videoStories: ImpactPageData['videoStories'];
}>;

export function usePetitionStarters(): Result {
	const {
		data: { videoStories },
	} = useImpactPageData();

	return {
		data: { videoStories },
	};
}
